<div class="calendar">
  <mat-calendar [selected]="dateRange" (selectedChange)="rangeChanged($event)"> </mat-calendar>
</div>
